import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
interface FooterLink {
  label: string;
  href: string;
}

/** Sólo enlaces con destino real (no hay páginas legales en el proyecto). */
const LEGAL_LINKS: FooterLink[] = [{
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="bg-sand" data-id="element-94" data-mp="36q953aee36tp">
      <div className="mx-auto max-w-5xl px-5 py-10 sm:py-12" data-id="element-95" data-mp="3uf0n58y9m8sr">
        <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:justify-between" data-id="element-96" data-mp="3uftmvpyt3y1e">
          <div data-id="element-97" data-mp="387e5ix8d5do">
            <p className="font-display text-[1.25rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.45rem]" data-id="element-98" data-mp="36mtcl0px0t0">
              500+ Recetas <span className="mark-yellow" data-id="element-99" data-mp="3qcdsl0a7m9rv">Keto + Sin TACC</span>
            </p>
            <p className="mt-2 font-sans text-[0.8rem] text-taupe" data-id="element-100" data-mp="29ynnprb9nhh6">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-bold text-gold-deep transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-101" data-mp="2eyt94pqy07qt">
                Creativo Digital™
              </a>
            </p>
          </div>

          <ul className="space-y-2 text-[0.82rem]" data-id="element-102" data-mp="3q726wh1myyaq">
            <li data-id="element-103" data-mp="82ienymgqkhh">
              <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-104" data-mp="828qmgkzanef">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-105" data-mp="cu8tagsfnuep">
                  <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden strokeWidth={2.5} data-id="element-106" data-mp="qtro67w8h992" />
                </span>
                soporte@creativodigital.shop
              </a>
            </li>
            <li data-id="element-107" data-mp="twxv9kvlbuel">
              <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-108" data-mp="tt9z0dyrgtw6">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-109" data-mp="1cnyqbxtlb5sv">
                  <InstagramIcon className="h-4 w-4 text-gold-deep" aria-hidden strokeWidth={2.5} data-id="element-110" data-mp="1mjsd0a10wfod" />
                </span>
                @creativodigitalstudio
              </a>
            </li>
            <li data-id="element-111" data-mp="1rgiqqqpcuz6m">
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-112" data-mp="3obew7peob6aa">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-113" data-mp="21mthe5ke6s0s">
                  <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden strokeWidth={2.5} data-id="element-114" data-mp="1wnz1bbdt7hkd" />
                </span>
                www.creativodigital.shop
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-stone pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-115" data-mp="2pc4mfz8rz8kq">
          <ul className="flex flex-wrap gap-x-4 gap-y-1.5 font-sans text-[0.74rem] text-taupe/80" data-id="element-116" data-mp="2kbqai641zehf">
            {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-117" data-mp="18y4ouuxejv0n">
                <a href={link.href} className="transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-118" data-mp="18z5ycuyrs9g9">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <p className="font-sans text-[0.74rem] text-taupe/80" data-id="element-119" data-mp="2woamwhhjdtms">
            © Creativo Digital™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}